import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { InfoAlerts, Informational } from "../../../../Constant";
import { INFO_SWEETALERT } from "../../../../Data/Bonus Ui/SweetAlert";

const InfoAlert = () => {
  const displayAlert = () => {
    SweetAlert.fire({ text: "Please Click on this button it's big surprise for you.",confirmButtonColor:"#33BFBF" }).then((result) => {
      if (result.isConfirmed) {
        SweetAlert.fire({ text: "Thank you for visit Boho theme : true" ,confirmButtonColor:"#33BFBF"});
      } else {
        SweetAlert.fire({ text: "Thank you for visit Boho theme : null",confirmButtonColor:"#33BFBF" });
      }
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={InfoAlerts} span={INFO_SWEETALERT} />
        <CardBody className="btn-showcase">
          <Btn color="info" className="sweet-1" type="button" onClick={displayAlert}>
            {Informational}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default InfoAlert;
